export const dotPathToBracketPath = (dotPath: string): string => {
  return dotPath
    .split(".")
    .map((part) => (Number.isInteger(+part) ? `[${part}]` : `.${part}`))
    .join("")
    .replace(/^\./, "");
};

export const validateByTemplate = (
  state: any,
  required: any,
  path: string[] = []
): Record<string, string> => {
  let errors: Record<string, string> = {};

  for (const key in required) {
    const currentPath = [...path, key];
    const errorPath = dotPathToBracketPath(currentPath.join("."));
    const stateValue = state?.[key];
    const requiredValue = required[key];

    if (Array.isArray(requiredValue)) {
      if (!Array.isArray(stateValue)) {
        errors[errorPath] = "Expected an array";
        continue;
      }

      const isSelfCheck =
        typeof requiredValue[0] === "object" && requiredValue[0]?.__self;

      if (isSelfCheck) {
        stateValue.forEach((item: any, index: number) => {
          if (item === undefined || item === null || item === "") {
            const itemPath = dotPathToBracketPath(
              [...currentPath, index.toString()].join(".")
            );
            errors[itemPath] = "Field is required";
          }
        });
      } else {
        stateValue.forEach((item: any, index: number) => {
          const innerErrors = validateByTemplate(item, requiredValue[0], [
            ...currentPath,
            index.toString(),
          ]);
          errors = { ...errors, ...innerErrors };
        });
      }
    } else if (typeof requiredValue === "object") {
      const nestedErrors = validateByTemplate(
        stateValue || {},
        requiredValue,
        currentPath
      );
      errors = { ...errors, ...nestedErrors };
    } else {
      if (
        stateValue === undefined ||
        stateValue === null ||
        (typeof stateValue === "string" && stateValue.trim() === "")
      ) {
        errors[errorPath] = "Field is required";
      }
    }
  }

  return errors;
};

const deepClone = (obj: any): any => {
  if (obj === null || typeof obj !== 'object') return obj;
  if (Array.isArray(obj)) return obj.map(deepClone);
  const result: any = {};
  for (const key in obj) {
    result[key] = deepClone(obj[key]);
  }
  return result;
};

export const updateNestedField = (obj: any, path: string, value: any): any => {
  const pathParts = path.replace(/\[(\d+)\]/g, ".$1").split(".");
  // const newObj = JSON.parse(JSON.stringify(obj));
  const newObj = deepClone(obj);
  let current = newObj;

  for (let i = 0; i < pathParts.length - 1; i++) {
    const key = pathParts[i];
    if (!(key in current)) {
      const nextKey = pathParts[i + 1];
      current[key] = /^\d+$/.test(nextKey) ? [] : {};
    }
    current = current[key];
  }

  current[pathParts[pathParts.length - 1]] = value;

  return newObj;
};
